import { axiosAuth } from "./axiosInstances";

// KHAN-236: REST/Django naming standardization. El backend paso de
// booksPerClasses/{insertnewBooksPerClasses,listAllBooksPerClasses,
// listBooksPerClassesid/<id>} (verbos en el path) a un unico recurso REST
// books-per-classes/ con metodo HTTP + el filtro ?class=. Se preservan los
// nombres de las funciones exportadas y los parametros/campos del body
// (booksid/classesid/order/isactive) para no tocar a los consumidores.
export async function newBookPerClass(booksid, classesid, order, isactive) {
  return axiosAuth().post("books-per-classes/", {
    booksid: booksid,
    classesid: classesid,
    order: order,
    isactive: isactive,
  });
}

export async function listedBooksPerClasses() {
  return axiosAuth().get("books-per-classes/");
}

export async function listedBooksPerClassesById(classId) {
  return axiosAuth().get("books-per-classes/?class=" + classId);
}
